import { Record } from "./record";
import type { EnumRef } from "./types";


export type Enum<T> =
    T extends string ?
    (string extends T ? never : T) :
    T extends number ?
    (number extends T ? never : T) :
    never;

export namespace Enum
{
    export function isEnum<T extends string | number>(enumRef: EnumRef<T>, value: unknown): value is Enum<T>
    {
        const exists = Record.values(enumRef).some(item => item == value);
        return exists;
    }

    export function getKey<T extends EnumRef>(enumRef: T, value: T[keyof T]): keyof T | undefined
    {
        return Record.keys(enumRef).find(key => enumRef[key] == value);
    }

    export const values: <T extends EnumRef>(enumRef: T) => T[keyof T][] = Record.values;

    // export function getValues<T extends EnumRef>(enumRef: T): T[keyof T][]
    // {
    //     return Record.values(enumRef) as T[keyof T][];
    // }

    // export function isEnumValue<T extends EnumRef>($enum: T, value: unknown): value is T[keyof T]
    // {
    //     return isEnum($enum, value);
    // }

    // export function getKey<T extends EnumRef>(enumRef: T, value: T[keyof T]): keyof T | undefined
    // {
    //     return Record.keys(enumRef).find(key => enumRef[key] == value);
    // }

    // export function getValues<T extends string | number>($enum: EnumRef<T>): T[keyof T][]
    // {
    //     return Object.values($enum) as T[keyof T][];
    // }
}
